import type { Plugin } from 'vue'

export default [] as Plugin[]
